// extracted by mini-css-extract-plugin
module.exports = {"sideWrapper":"Navigation_sideWrapper__3HhkB","isOnSide":"Navigation_isOnSide__DV8tV","sideItem":"Navigation_sideItem__1h8D3","sideLink":"Navigation_sideLink__3Kkub"};